export const MY_BOOKINGS_QUERY_ROOT = "myBookings";
export const MY_BOOKING_QUERY_ROOT = "myBooking";
export const MY_BOOKINGS_NOTIFICATION_QUERY_ROOT = "myBookingsNotification";

// email/brand/shop font partie des clés pour isoler le cache par utilisateur
// (évite qu'un compte lise les données mises en cache d'un autre après login).
export const MY_BOOKINGS_QUERY_KEYS = {
	upcoming: email => [MY_BOOKINGS_QUERY_ROOT, "upcoming", email],
	past: email => [MY_BOOKINGS_QUERY_ROOT, "past", email],
	detail: (bookingReference, brand, email, isAuthenticated) => [
		MY_BOOKING_QUERY_ROOT,
		bookingReference,
		brand,
		// The booking search stores the email as typed, then as returned by the API.
		email?.toLowerCase(),
		isAuthenticated,
	],
	notification: (brand, shop, email) => [MY_BOOKINGS_NOTIFICATION_QUERY_ROOT, brand, shop, email],
};
